module.exports = "pegasus/assets/circle_x_gray.png";